module.exports = "https://static.energy5.com/_next/static/images/completeCustomizationImage-331588e7469aae143aac63bf6e951480.jpg";